import "./back-in-stock-form";
import "./back-in-stock-button";
import "./product-form-swatches";
import "./media-gallery";
import "./pdp-variant-button";
import "./product-form";
import "./variant-input";
import "./gift-card-recipient";
import "./mobile-sticky-atc";
import "./sticky-atc-bar";
import "./desktop-sticky-atc-disclosure";
import "./product-low-stock";

class MainProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const cb = (entries) => {
      document.dispatchEvent(
        new CustomEvent("atc-bar-sticking", {
          detail: { sticking: !entries[0].isIntersecting },
        })
      );
    };

    this.observer = new IntersectionObserver(cb, {});
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get("main-product")) {
  customElements.define("main-product", MainProduct);
}
